<!-- Layout -->
<div class="h-screen w-full overflow-hidden relative">

    <div
        class="h-[120px] w-full bg-[#0090FF] rounded-b-[45px] flex items-center justify-between px-8 relative overflow-hidden">
        <img src="assets/images/kossaya/bnb-background.svg" alt="bg-header"
            class="absolute top-[-50px] left-[14%] z-0 w-[80%] h-[160%] object-cover object-top">
        <div class="z-10 flex items-center justify-between w-full">
            <label class="text-white text-6xl font-bold">{{ room?.label }}</label>
            <img src="assets/images/kossaya/bnb_mansion_logo.png" alt="Logo Kossaya" class="h-10 w-auto">

            <ng-container *ngIf="isOccupied">
                <img src="assets/images/kossaya/occupied.svg" alt="Occupied">
            </ng-container>

            <ng-container *ngIf="!isOccupied">
                <img src="assets/images/kossaya/available-icon.svg" alt="Available">
            </ng-container>
        </div>
    </div>


    <!-- VIdeo Idle -->
    <div class="h-[calc(100vh-260px)] overflow-hidden" *ngIf="mode === 'idle' && !isOccupied">
        <h1></h1>
    </div>

    <!-- Fasilitas Kamar -->
    <div class="h-[calc(100vh-260px)] overflow-hidden" *ngIf="mode === 'facility' && !isOccupied">
        <h1></h1>
    </div>

    <!-- Welcome To -->
    <div class="h-[calc(100vh-260px)] overflow-hidden" *ngIf="mode === 'welcome'">
        <img src="assets/images/kossaya/SelamatDatang.jpg" alt=""
            class="w-full h-full object-cover absolute top-0 left-0 z-[-1]">

        <!-- Ditambahkan drop-shadow-xl agar teks putih tetap terbaca walau background terang -->
        <div class="w-full h-fit flex justify-between p-[32px] drop-shadow-xl">

            <div class="text-white text-3xl" style="text-shadow: 2px 2px 4px rgba(0,0,0,0.7);">
                <p class="font-medium">Selamat Datang</p>
                <h1 class="text-6xl leading-[100%] mt-1 mb-2">
                    {{ formattedName.firstPart }} <span class="font-bold">{{ formattedName.lastPart }}</span>
                </h1>
                <p class="">{{ currentTime | date:'dd-MM-yyyy' }}</p>
                <p class="text-md">{{ currentTime | date:'HH:mm:ss' }} WIB</p>
            </div>

            <div class="w-[250px] h-[250px] flex items-start justify-end"
                style="text-shadow: 2px 2px 4px rgba(0,0,0,0.7);">
                <div class="flex flex-col items-center gap-1">
                    <ng-container *ngIf="currentTime.getHours() < 18">
                        <img src="assets/images/kossaya/pagi-icon.svg" alt="" class="w-[50%] drop-shadow-md">
                    </ng-container>
                    <ng-container *ngIf="currentTime.getHours() >= 18">
                        <img src="assets/images/kossaya/malam-icon.svg" alt="" class="w-[50%] drop-shadow-md">
                    </ng-container>

                    <p class='text-xl pt-1 text-white font-medium'>{{ weather?.temp_c }}&#176;</p>
                </div>

            </div>
        </div>
    </div>


    <!-- Goodnight -->
    <div class="h-[calc(100vh-260px)] overflow-hidden" *ngIf="mode === 'goodnight' && isOccupied">
        <img src="assets/images/kossaya/SelamatMalam.jpg" alt=""
            class="w-full h-full object-cover absolute top-0 left-0 z-[-1] ">

        <div class="w-full h-fit flex justify-between p-[32px]">

            <div class="text-white text-3xl">
                <p class="">{{ greeting }}</p>
                <h1 class="text-6xl leading-[100%]">
                    {{ formattedName.firstPart }} <span class="font-bold">{{ formattedName.lastPart }}</span>
                </h1>
                <p class="">{{ currentTime | date:'dd-MM-yyyy' }}</p>
                <p class="text-md">{{ currentTime | date:'HH:mm:ss' }} WIB</p>
            </div>

            <div class="w-[250px] h-[250px] flex items-start justify-end">
                <div class="flex flex-col items-center gap-1">
                    <ng-container *ngIf="currentTime.getHours() < 18">
                        <img src="assets/images/kossaya/pagi-icon.svg" alt="" class="w-[50%]">
                    </ng-container>
                    <ng-container *ngIf="currentTime.getHours() >= 18">
                        <img src="assets/images/kossaya/malam-icon.svg" alt="" class="w-[50%]">
                    </ng-container>

                    <p class='text-xl pt-1 text-white'>{{ weather?.temp_c }}&#176;</p>
                </div>

            </div>
        </div>
    </div>


    <!-- Goodmorning -->
    <div class="h-[calc(100vh-260px)] overflow-hidden" *ngIf="mode === 'goodmorning' && isOccupied">
        <img src="assets/images/kossaya/SelamatPagi.jpg" alt=""
            class="w-full h-full object-cover absolute top-0 left-0 z-[-1] ">

        <div class="w-full h-fit flex justify-between p-[32px]">

            <div class="text-white text-3xl">
                <p class="">{{ greeting }}</p>
                <h1 class="text-6xl leading-[100%]">
                    {{ formattedName.firstPart }} <span class="font-bold">{{ formattedName.lastPart }}</span>
                </h1>
                <p class="">{{ currentTime | date:'dd-MM-yyyy' }}</p>
                <p class="text-md">{{ currentTime | date:'HH:mm:ss' }} WIB</p>
            </div>

            <div class="w-[250px] h-[250px] flex items-start justify-end">
                <div class="flex flex-col items-center gap-1">
                    <ng-container *ngIf="currentTime.getHours() < 18">
                        <img src="assets/images/kossaya/pagi-icon.svg" alt="" class="w-[50%]">
                    </ng-container>
                    <ng-container *ngIf="currentTime.getHours() >= 18">
                        <img src="assets/images/kossaya/malam-icon.svg" alt="" class="w-[50%]">
                    </ng-container>

                    <p class='text-xl pt-1 text-white'>{{ weather?.temp_c }}&#176;</p>
                </div>

            </div>
        </div>

    </div>


    <!-- Menu Button -->
    <div class="bg-[#0090FF] h-[140px] w-full flex items-center justify-center relative overflow-hidden"
        *ngIf="mode === 'idle' || mode === 'facility'">
        <img src="assets/images/kossaya/bnb-background.svg" alt="bg-header"
            class="absolute top-[-50px] left-[14%] z-0 w-[80%] h-[160%] object-cover object-top">
        <button
            class="w-fit h-fit py-[14px] px-[32px] bg-[#fff] rounded-[26px] shadow-lg font-semibold text-[#247ABC] relative z-10">
            Pesan Sekarang
        </button>
    </div>

    <!-- Menu Facility -->
    <div class="bg-[#0090FF] h-[140px] w-full flex items-center justify-center gap-3 relative overflow-hidden"
        *ngIf="mode === 'welcome'">
        <img src="assets/images/kossaya/bnb-background.svg" alt="bg-header"
            class="absolute top-[-50px] left-[14%] z-0 w-[80%] h-[160%] object-cover object-top">
        <div
            class="bg-white w-[84px] h-[84px] rounded-[18px] text-[#247ABC] shadow-md flex items-center justify-center relative z-10">
        </div>
        <div
            class="bg-white w-[84px] h-[84px] rounded-[18px] text-[#247ABC] shadow-md flex items-center justify-center relative z-10">
        </div>
        <div
            class="bg-white w-[84px] h-[84px] rounded-[18px] text-[#247ABC] shadow-md flex items-center justify-center relative z-10">
        </div>
        <div
            class="bg-white w-[84px] h-[84px] rounded-[18px] text-[#247ABC] shadow-md flex items-center justify-center relative z-10">
        </div>
    </div>
</div>